import { useEffect } from 'react'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/** Header heights, px. Compact when the ground-truth bar is collapsed on the
 *  media page — the bar was the only thing needing the tall header, and the
 *  viewer runs underneath it, so a shorter header shows more slide. */
export const HEADER_H = 80
export const HEADER_H_COMPACT = 48

interface ChromeLayoutStore {
  /** Ground-truth bar collapsed to its count pill (browser preference, like the theme) */
  gtBarCollapsed: boolean
  setGtBarCollapsed: (collapsed: boolean) => void
}

export const useChromeLayoutStore = create<ChromeLayoutStore>()(
  persist((set) => ({ gtBarCollapsed: false, setGtBarCollapsed: (gtBarCollapsed) => set({ gtBarCollapsed }) }), {
    name: 'chrome-layout',
  })
)

/** Publishes the header height as `--header-h` on <html> so every piece of
 *  chrome anchored below the header (rails, chips, drawing button, corner-button
 *  insets) follows it with a CSS transition. Mount once in AuthenticatedLayout. */
export function useHeaderHeight(compactAllowed: boolean): number {
  const collapsed = useChromeLayoutStore((s) => s.gtBarCollapsed)
  const height = compactAllowed && collapsed ? HEADER_H_COMPACT : HEADER_H
  useEffect(() => {
    document.documentElement.style.setProperty('--header-h', `${height}px`)
  }, [height])
  return height
}
